import { star_games_order } from "../../constants/slot_games.js";
import { userData } from "../../js/api/profile.js";
import IframeModal from "../components/IframeModal.js";
import { getCurrentBalance } from "../../js/api/balance.js";
import { getStargames, getJackpotsStarGame, getPopularStargames, getNewStargames, getHallId } from "../../js/api/deluxecasino.js"
import { _t } from "../../services/TranslationService.js";
import { sgRegisterFirstTime, sgGotoGame } from "../../js/api/liveCasino.js";
import Utils from "../../services/Utils.js";
import { isEuroVegasDomain } from "../../js/constants/global-variables.js";

// VIP Casino Stargames
let Stargames = {
    render: async () => {
      const casinoEnabled = localStorage.getItem("casinoEnabled") === "1";
      const noAccess = isEuroVegasDomain || !casinoEnabled;
      
      if (noAccess) {
        return `
          <h2 style="color:white;text-align:center;margin-top:50px;">Star Games are not supported on this domain.</h2>
          <div style="text-align:center;margin-top:20px;">
            <a href="#/" style="color:white;">Go to homepage</a>
          </div>
        `;
      }

        let hasActiveTab = false;
        let hall = null;

        const hallRes = await getHallId();
        if (hallRes) {
          hall = hallRes.hall;
        }


        const [getGames, popularGames, newGames] = await Promise.all([
          getStargames(hall),
          getPopularStargames(hall),
          getNewStargames(hall)
        ]);

        const crashGamesIds = [4999, 2046, 2044, 2048, 6479, 4998, 4997, 4995];
        const games = crashGamesIds.map(id => ({
          id,
          name: "Mystic Fortune",
          icon: `https://content.stargame.solutions/api/game/icon2/${id}`,
          icon2: `https://content.stargame.solutions/api/game/icon4/${id}`,
          isaristocrat: 0,
          htmlposition: 10404,
          vendorflags: 0,
          gametype: 46,
          url: `https://apiserver.solutions/tote_opbetting3?gameid=${id}&x=1926464069`,
          width: 1024,
          height: 768,
        }));
        const crashGamesFamily = {
          family: {
            name: "Crash Games",
            games,
            id: 1,
          },
        };
        getGames.gamelist = [crashGamesFamily, ...(getGames.gamelist || [])];


        const transformedArray = getGames.gamelist
          .map((obj, i) => {
            const orderIndex = star_games_order.indexOf((obj.family.name ?? '').toUpperCase())
            return {
              family: obj.family,
              sortIndex: orderIndex === -1 ? star_games_order.length + (i + 1) : orderIndex,
            }        
          })
          .sort((a,b) => (a.sortIndex > b.sortIndex) ? 1 : ((b.sortIndex > a.sortIndex) ? -1 : 0))
          .map(obj => obj.family);

        function transformArrayToObject(array) {
            const result = {};

            array.forEach(obj => {
                const name = obj.name.trim();
                const games = obj.games;

                result[name] = games;
            });

            return result;
        }

        const transformedObject = transformArrayToObject(transformedArray);

        let groupView = `
          <div class="searchGameHolder">
              <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5s4.
        5 2.01 4.5 4.5S11.99 14 9.5 14z"/></svg>
              <input type="search" id="searchGameInput" placeholder="${_t('Search game')}..." />
          </div>
        `;

        let groupBtnView = ``;

        // Add popular games
        if (popularGames?.gamelist && popularGames.gamelist.family?.games?.length) {
          const games = popularGames.gamelist.family.games;
          const name = popularGames.gamelist.family.name;
          groupBtnView += `<div class="groupFamilyBtn active" data-btn-target="${name.toLowerCase()}" data-sortindex="0"><span class="">${_t(name)}</span></div>`;
          for (const element of games) {
            groupView += `
              <div class="game animation-element" game="${element.id}" group="${name.toLowerCase()}">
                <img src="${element.icon2 ?? element.icon}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
                <span>${element.name}</span>
              </div>`;
          }
          hasActiveTab = true;
        }

        // Add new games
        if (newGames?.gamelist && newGames.gamelist.family?.games?.length) {
          const games = newGames.gamelist.family.games;
          const name = newGames.gamelist.family.name;
          groupBtnView += `<div class="groupFamilyBtn ${!hasActiveTab ? 'active' : ''}" data-btn-target="${name.toLowerCase()}" data-sortindex="0"><span class="">${_t(name)}</span></div>`;
          for (const element of games) {
            groupView += `
              <div class="game animation-element" game="${element.id}" group="${name.toLowerCase()}" ${hasActiveTab ? 'style="display: none;' : ''}">
                <img src="${element.icon2 ?? element.icon}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
                <span>${element.name}</span>
              </div>`;
          }
          hasActiveTab = true;
        }
        
        groupBtnView += `<div class="groupFamilyBtn ${!hasActiveTab ? 'active' : ''}" data-btn-target="all" data-sortindex="0"><span class="">${_t('All games')}</span></div>`;
        $.each(transformedObject, function (i, item) {

          let index = star_games_order.indexOf(i.toUpperCase()) + 3;
          if (index === 2) index = star_games_order.length + (i + 3);

          let gamesItemView = ``;
          groupBtnView += `<div class="groupFamilyBtn" data-btn-target="${i.replaceAll(' ', '')}" data-sortindex="${index}" style="order: ${index}"><span class="">${i}</span></div>`;

          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              const element = item[key];
              // console.log(element);
              gamesItemView += `
                <div class="game animation-element" game="${element.id}" group="${i.replaceAll(' ', '')}" ${hasActiveTab ? 'style="display: none;' : ''}">
                  <img src="${element.icon2 ?? element.icon}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
                  <span>${element.name}</span>
                </div>`;
            }
          }
          groupView += `${gamesItemView}`;
        });

        let view = /*html*/ `
         <div class="modalHelperHolder">
            <div class="modalHelperPosition">
                <span>Zgjedh monedhen per casino</span>
                <select id="coinSelectorSelect">
                </select>
                <a class="submitBtn modalHandler" id="submitCoinSelected">Vazhdo</a>
            </div>
        </div>

        <h1 class="deluxeTitle">Welcome To VIP Casino</h1>

        <div class="machineBoxesHolder landingMashineBox" style="overflow-x: auto; display: none !important;">
                <div class="machineBox " game="">
                    <a href="#/slots">
                        <img src="img/slider-01.svg"/>
                    </a>
                </div>
                <div class="machineBox " game="">
                    <a href="#/slots">
                        <img src="img/slider-02.svg"/>
                    </a>
                </div>
                <div class="machineBox " game="">
                    <a href="#/slots">
                        <img src="img/slider-03.svg"/>
                    </a>
                </div>
                <div class="machineBox " game="">
                    <a href="#/slots">
                        <img src="img/slider-04.svg"/>
                    </a>
                </div>
                <div class="machineBox " game="">
                    <a href="#/slots">
                        <img src="img/slider-05.svg"/>
                    </a>
                </div>
                <div class="machineBox " game="">
                    <a href="#/slots">
                        <img src="img/slider-06.svg"/>
                    </a>
                </div>
            </div>
            <div class="fragment jackpots-container has-show-more jack-related jackpots show-more-handle-taphold shown-more-yes">

                <div class="jackpots-cont-wrapper second-row-jackpots mainStar">
                    <div class="jackpotAnimation jackpotSecond">

                  <div class="horizontalBar topBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar rightBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="horizontalBar bottomBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar leftBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="cornerJackpot topLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot topRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="jackpot JCK jackpotID_2 jackpot_1" data-jackid="2" data-valuta="eur">
                     <div class="jack-inside-lights">
                        <div class="jackpot-pulsing-bg jackpot_pbg_2" style=""></div>
                        <i class="icon icon-weekly-jack icon-jcolor-2 jackpot-icon"></i>
                        <div class="jack-name">
                           <div class="jackname ">Diamond JackPot</div>
                           <span class="jack-value"><span class="numbers" id="diamondJackpot"></span><span class="valuta_sign valutaID_eur">€</span></span>
                        </div>
                     </div>
                  </div>
                </div>
                <div class="jackpotAnimation jackpotThird">
                  <div class="horizontalBar topBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar rightBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="horizontalBar bottomBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar leftBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="cornerJackpot topLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot topRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="jackpot JCK jackpotID_1 jackpot_2" data-jackid="1" data-valuta="eur">
                     <div class="jack-inside-lights">
                        <div class="jackpot-pulsing-bg jackpot_pbg_1" style=""></div>
                        <i class="icon icon-daily-jack2 icon-jcolor-3 jackpot-icon"></i>
                        <div class="jack-name">
                           <div class="jackname ">Gold JackPot</div>
                           <span class="jack-value"><span class="numbers" id="goldJackpot"></span><span class="valuta_sign valutaID_eur">€</span></span>
                        </div>
                     </div>
                  </div>
                </div>
            </div>
            <div class="fragment jackpots-container has-show-more jack-related jackpots show-more-handle-taphold shown-more-yes">
             
                <div class="jackpots-cont-wrapper second-row-jackpots">
                    <div class="jackpotAnimation jackpotSecond">

                  <div class="horizontalBar topBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar rightBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="horizontalBar bottomBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar leftBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="cornerJackpot topLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot topRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="jackpot JCK jackpotID_2 jackpot_1" data-jackid="2" data-valuta="eur">
                     <div class="jack-inside-lights">
                        <div class="jackpot-pulsing-bg jackpot_pbg_2" style=""></div>
                        <i class="icon icon-weekly-jack icon-jcolor-2 jackpot-icon"></i>
                        <div class="jack-name">
                           <div class="jackname ">Silver JackPot</div>
                           <span class="jack-value"><span class="numbers" id="silverJackpot"></span><span class="valuta_sign valutaID_eur">€</span></span>
                        </div>
                     </div>
                  </div>
                </div>
                <div class="jackpotAnimation jackpotThird">
                  <div class="horizontalBar topBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar rightBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="horizontalBar bottomBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar leftBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="cornerJackpot topLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot topRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="jackpot JCK jackpotID_1 jackpot_2" data-jackid="1" data-valuta="eur">
                     <div class="jack-inside-lights">
                        <div class="jackpot-pulsing-bg jackpot_pbg_1" style=""></div>
                        <i class="icon icon-daily-jack2 icon-jcolor-3 jackpot-icon"></i>
                        <div class="jack-name">
                           <div class="jackname ">Bronze JackPot</div>
                           <span class="jack-value"><span class="numbers" id="bronzeJackpot"></span><span class="valuta_sign valutaID_eur">€</span></span>
                        </div>
                     </div>
                  </div>
                </div>
            </div>
            </div>
            <div class="slotsCatHolder">
                <div class="slotsCatHelper" id="slotsCatBtn">
                    ${groupBtnView}
                </div>
            </div>
            <div class="slotsMainWrapper deluxeView">
              <div id="main" style="text-align: left;">
                ${groupView}
              </div>

              <div id="game_container">
                  <div id="game_flash"></div>
              </div>
            </div>
       `;
        return view;
    },
    after_render: async () => {
        var $wrapper = $('.slotsCatHelper');
        $wrapper.find('.groupFamilyBtn').sort(function(a, b) {
            return +a.dataset.sortindex - +b.dataset.sortindex;
        })
        .appendTo($wrapper);

        $('body .valuta_sign').text('')
        
        let key1;
        let key2;
        let sessionid;
        let userId = localStorage.getItem('user_id');

        let starGameId = localStorage.getItem("starGameId");
        const response = await sgRegisterFirstTime();


        if (response && response.token !== null) {
            localStorage.setItem('access_token', response.token.jwt);
        }
        if (starGameId == null || starGameId == undefined || starGameId == '') {
            // const response = await checkLiveCasino();
            // console.log(response, 'response-eeee');
        } else {

            if( localStorage.getItem('role') === 'User'){
                let checkStatus = await sgGotoGame();
                key1 = checkStatus.key1;
                key2 = checkStatus.key2;
                sessionid = checkStatus.sessionid;
                if (checkStatus.success == true) {
                    setInterval(async () => {
                        let jackpots = await getJackpotsStarGame(sessionid, key1, key2)
                        if (jackpots && jackpots.length >= 4) {
                          $('body #bronzeJackpot').text(jackpots[0].value)
                          $('body #silverJackpot').text(jackpots[1].value)
                          $('body #goldJackpot').text(jackpots[2].value)
                          $('body #diamondJackpot').text(jackpots[3].value)
                        }
                    }, 5000);
                }
            }else {
                $('body #bronzeJackpot').text('N/A')
                $('body #silverJackpot').text('N/A')
                $('body #goldJackpot').text('N/A')
                $('body #diamondJackpot').text('N/A')
            }
        }
        
        const userDataBody = await userData(localStorage.getItem("user_id"));
        if (!$("body").hasClass("bg-black")) {
            $("body").addClass("bg-black");
        }

        $("body").click(function (e) {
            if (!$(e.target).is(".modalHelperPosition,.modalHelperPosition *")) {
                $(".modalHelperHolder").removeClass("active");
            }
        });

        setCurrentBalanceForSlots();

        jackpotMainAnimation();
        jackpotSecondAnimation();
        jackpotThirdAnimation();

        setInterval(jackpotMainAnimation, $(".jackpotMain .light").length * 75);
        setInterval(jackpotSecondAnimation, $(".jackpotSecond .light").length * 70);
        setInterval(jackpotThirdAnimation, $(".jackpotThird .light").length * 70);

        function jackpotMainAnimation() {
            $(".jackpotMain .light").each(function (i, el) {
                setTimeout(function () {
                    $(el).addClass("active");
                    setTimeout(function () {
                        $(el).removeClass("active");
                    }, 155);
                }, i * 70);
            });
        }
        function jackpotSecondAnimation() {
            $(".jackpotSecond .light").each(function (i, el) {
                setTimeout(function () {
                    $(el).addClass("active");
                    setTimeout(function () {
                        $(el).removeClass("active");
                    }, 155);
                }, i * 70);
            });
        }
        function jackpotThirdAnimation() {
            $(".jackpotThird .light").each(function (i, el) {
                setTimeout(function () {
                    $(el).addClass("active");
                    setTimeout(function () {
                        $(el).removeClass("active");
                    }, 155);
                }, i * 70);
            });
        }

        $("body .landingMashineBox").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            centerMode: true,
            variableWidth: false,
            dots: false,
            prevArrow: false,
            nextArrow: false,
        });

        let catLengthWidth = 0;
        $(".groupFamilyBtn ").each(function (e) {
            catLengthWidth += $(this).outerWidth();
        });
        $("body .slotsCatHelper").css({
            width: catLengthWidth + 3 + "px",
        });

      // Filter games by category
      $("body").on("click", ".groupFamilyBtn", function (e) {
        let eventTarget = $(e.currentTarget).attr("data-btn-target");
        $("body .groupFamilyBtn").removeClass("active");
        $(e.currentTarget).addClass("active");
        if (eventTarget === 'all') {
          $('.game').show();
        } else {
          $(".game[group='" + eventTarget + "']").show();
          $(".game").not("[group='" + eventTarget + "']").hide();
        }
      });

      const selectedCategory = Utils.parseRequestURL().query.category;
      if (selectedCategory) {
        const normalizedCategory = decodeURIComponent(selectedCategory)
          .replace(/[-_\s]/g, "")
          .toLowerCase();
        const selectedCategoryButton = $("body .groupFamilyBtn")
          .filter(function () {
            return $(this)
              .attr("data-btn-target")
              .replace(/[-_\s]/g, "")
              .toLowerCase() === normalizedCategory;
          })
          .first();

        selectedCategoryButton.trigger("click");
      }

    // Search games
    $("#searchGameInput").unbind().on("keyup", function (e) {
      let value = $(e.currentTarget).val().toLowerCase();
      $("body .groupFamilyBtn").removeClass("active");
      $("body .groupFamilyBtn[data-btn-target='all']").addClass("active");
      if (!value) {
        $('.game').show();
        return;
      }
      $(".game").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    });
    $("#searchGameInput").on("search", function (e) {
      let value = $(e.currentTarget).val().toLowerCase();
      if (!value) {
        $('.game').show();
        return;
      }
    });

        $(".game").on("click", async function (e) {
            if (
                !localStorage.getItem("access_token") ||
                localStorage.getItem("access_token") == ""
            ) {
                alert("Login!");
                return;
            }

            if (userDataBody.casinoEnabled != "1") {
                alert("Nuk keni qasje ne lojet e Casino!");
                return;
            }

            let checkStatus = await sgGotoGame();
            key1 = checkStatus.key1;
            key2 = checkStatus.key2;
            sessionid = checkStatus.sessionid;

            $(e.currentTarget).addClass("clicked");
            let gameId = $(e.currentTarget).attr('game');
            let gameName = $(e.currentTarget).children('span').text();

            setTimeout(async function () {

                const gameLink = `https://apiserver.solutions/showgame?gameid=${gameId}&sid=${sessionid}&key1=${key1}&key2=${key2}&username=${userId}&uwidth=auto&uheight=auto`;       

                IframeModal.loadIframe(gameLink, true);
                IframeModal.show(gameName);
                $(e.currentTarget).removeClass("clicked");
            }, 2000);
        });
    },
};

async function setCurrentBalanceForSlots() {
    var currentBalanceResult = await getCurrentBalance();
    const getCurrencySignById = (id) => {
      switch (id) {
        case "1":
          return "€"; // EURO
        case "2":
          return "L"; // LEK
        case "3":
          return "$"; // USD
        case "4":
          return "CHF"; // CHF fr
        case "5":
          return "£"; // GBP
        case "6":
          return "д"; // MKD
        case "7":
          return "CAD"; // CAD
        case "8":
          return "MAD"; // MAD
        case "9":
          return "cash"; // SEK
        default:
          return "/";
      }
    }

    if ( localStorage.getItem('role') === 'User' ){
      $('body .valuta_sign').text(getCurrencySignById(currentBalanceResult.casino_currency));
    } else {
      $('body .valuta_sign').text('')
    }

    if (currentBalanceResult.casino_currency) return;

    var coins = [];

    if (currentBalanceResult && currentBalanceResult.total_coins) {
        var allCoins = currentBalanceResult.total_coins.split("|");

        if (currentBalanceResult.total_coins.includes("|")) {
            var allCoins = currentBalanceResult.total_coins.split("|");

            for (let index = 0; index < allCoins.length; index++) {
                const coin = allCoins[index];
                const currency = coin.split(";")[0].split(".")[1];
                coins.push({
                    currency,
                    id: coin.split(";")[0].split(".")[0],
                });

                const value = coin.split(";")[1];
            }
        } else {
            if (currentBalanceResult.currency) {
                coins.push({
                    currency: currentBalanceResult.currency,
                    id: currentBalanceResult.currency_id,
                });
            } else {
                const currency = currentBalanceResult.total_coins
                    .split(";")[0]
                    .split(".")[1];
                coins.push({
                    currency,
                    id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
                });
            }
        }
    }

    renderCoins(coins);
    callSliderEvent();
}

async function renderCoins(coins) {
    coins.forEach((element) => {
        $("#coinSelectorSelect").append(`<option value="${element.id}">${element.currency}</option>`);
    });
}

function callSliderEvent() {
    if ($("body .modalHelperHolder").hasClass("active")) {
        $("body .modalHelperHolder").removeClass("active");
    } else {
        $("body .modalHelperHolder").addClass("active");
    }
}

export default Stargames;
